module.exports = __webpack_public_path__ + "img/cover-landing-moving-1440.jpg";